// extracted by mini-css-extract-plugin
module.exports = {"Group":"Group_Group__2PxPR","GroupFull":"Group_GroupFull__Rr_UD","Label":"Group_Label__2RNe0","Error":"Group_Error__ct_UP"};